export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/about-outer-arc.009bd8b0-d4dc6f.png";